import { ClaimCenterWithBookables } from '@interaction-gaming/game-data-service-browser-client'
import { ToggleGroup } from 'radix-ui'

import Checkmark from '@Assets/icons/checkmark.svg'
import { ReactSVG } from 'react-svg'

export type ClaimCenterCardProps = {
  details: ClaimCenterWithBookables
  isChecked: boolean
}

export const ClaimCenterCheckboxCards = ({ details, isChecked }: ClaimCenterCardProps) => {
  return (
    <ToggleGroup.Item
      className={`choose-location-screen__card`}
      key={details.id}
      value={details.id}
      role="checkbox"
      aria-checked={isChecked}>
      <h3>{details.name}</h3>
      <section>
        <p>{details.buildingName}</p>
        <p>{details.address1}</p>
        <p>{details.address2}</p>
        <p>
          {details.city}, {details.region} {details.postalCode}
        </p>
      </section>
      <div className="choose-location-screen__icon-container">
        <ReactSVG className={`choose-location-screen__icon-checkmark`} src={Checkmark} />
      </div>
    </ToggleGroup.Item>
  )
}
